import { defineMessages } from 'react-intl';

export default defineMessages({
  requiredValidationError: {
    id: 'common.titles.validationError',
    defaultMessage: '{field} is required.',
  },
  invalidValidationError: {
    id: 'common.forms.validationInvalidError',
    defaultMessage: 'Please enter a valid {field}.',
  },
});
